import React, { Component } from 'react';
import './style.css'
import * as mat from 'material-ui'
import FaGraduationCap from 'react-icons/lib/fa/graduation-cap';
import FaKey from 'react-icons/lib/fa/key'
import { FormErrors } from './formErrors';
import { SignUpAction } from '../../action/authAction'
import { connect } from 'react-redux'
import NumberFormat from 'react-number-format'

class SIGNUP extends Component {
    constructor(props) {
        super(props);
        this.state = {
            school: 'School',
            userName: '',
            email: '',
            phone: '',
            schoolName: '',
            students: '',
            schoolAddress: '',
            password: '',
            key: '',
            formErrors: { email: '', password: '', userName: '', school: '', phone: '', schoolName: '', students: '', schoolAddress: '' },
            schoolValid: false,
            userNameValid: false,
            emailValid: false,
            passwordValid: false,
            formValid: false,
            phoneValid: false,
            schoolNameValid: false,
            studentsNumberValid: false,
            schoolAddressValid: false,
            value: '',
            selectError: false


        }
        this.handleChange = this.handleChange.bind(this);
    }


    handleChange(event) {
        this.setState({ value: event.target.value });
    }

    handleUserInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value },
            () => { this.validateField(name, value) });
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        // let schoolValid = this.state.schoolValid;
        let userNameValid = this.state.userNameValid;
        let emailValid = this.state.emailValid;
        let passwordValid = this.state.passwordValid;
        let phoneValid = this.state.phoneValid;
        let schoolNameValid = this.state.schoolNameValid;
        let studentsNumberValid = this.state.studentsNumberValid;
        let schoolAddressValid = this.state.schoolAddressValid;

        switch (fieldName) {
            // case 'school':
            //     schoolValid = value === 'School';
            //     fieldValidationErrors.This = schoolValid ? '' : ' time MAGE only available for School user';
            //     break;
            case 'userName':
                userNameValid = value;
                fieldValidationErrors.Name = userNameValid ? '' : ' must be 4 chracters';
                break;
            case 'email':
                emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
                fieldValidationErrors.Email = emailValid ? '' : ' is invalid (example@gmail.com)';
                break;
            case 'phone':
                phoneValid = value.match(/^\+\d{1,3}\d{9,10}$/);
                fieldValidationErrors.Enter = phoneValid ? '' : ' valid number';
                break;
            case 'schoolName':
                schoolNameValid = value;
                fieldValidationErrors.SchoolName = schoolNameValid ? '' : ' must be 12 chracters';
                break;
            case 'students':
                studentsNumberValid = value;
                fieldValidationErrors.No = studentsNumberValid ? '' : '. of students required';
                break;
            case 'schoolAddress':
                schoolAddressValid = value;
                fieldValidationErrors.SchoolAddress = schoolAddressValid ? '' : ' school address is required';
                break;
            case 'password':
                passwordValid = value.length >= 6;
                fieldValidationErrors.Password = passwordValid ? '' : ' is too short';
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            // schoolValid,
            userNameValid,
            emailValid,
            phoneValid,
            passwordValid,
            studentsNumberValid,
            schoolAddressValid,
            schoolNameValid
        }, this.validateForm);
    }

    validateForm() {
        this.setState({
            formValid: this.state.emailValid && this.state.passwordValid && this.state.userNameValid && this.state.phoneValid &&
                this.state.schoolNameValid && this.state.studentsNumberValid && this.state.schoolAddressValid
        });
    }
    SignUp() {
        let email = this.state.email;
        let phone = this.state.phone;
        let role = this.state.school;
        let userName = this.state.userName;
        let password = this.state.password;
        let schoolName = this.state.schoolName;
        let students = this.state.students;
        let schoolAddress = this.state.schoolAddress
        let key = this.state.key;
        let profile = 'https'
        if (this.state.value === null) {
            this.state.selectError = true
        }
        else {
            var schoolType = this.state.value
        }

        let signupData = {
            email,
            phone,
            role,
            password,
            userName,
            schoolName,
            students,
            schoolType,
            schoolAddress,
            profile,
            key
        }
        // console.log('signupData',signupData)
        this.props.SignUpAction(signupData);

    }



    render() {
        const {
            ALoader,
            Error,
            Success
        } = this.props;
        return (
            <div>
                <mat.Card
                    zDepth={0}
                    className='col-md-4 col-md-offset-4 col-xs-10 col-xs-offset-1 signup'
                >
                    {/* Login Header */}
                    <mat.AppBar
                        title='SIGN UP'
                        titleStyle={{ textShadow: '0px 2px 3px gray', fontSize: '3em', fontWeight: 'bold', color: '#41c4dd' }}
                        className='text-center'
                        showMenuIconButton={false}
                        style={{ backgroundColor: 'white' }}
                        zDepth={0}
                    />
                    <mat.CardText style={{ marginTop: '3%' }}>
                        {/* <div className="input-group input-group-lg">
                            <span className="input-group-addon"><i className="glyphicon glyphicon-tags"></i></span>
                            <input
                                name="role"
                                className="form-control"
                                defaultValue="available for school"
                                aria-label="role"
                                disabled={true}
                                required
                                aria-describedby="sizing-addon1"
                            // value={this.state.role}
                            // onChange={this.handleUserInput}
                            />
                        </div>
                        <br /> */}
                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><FaGraduationCap /></span>
                            <input
                                name="school"
                                className="form-control"
                                placeholder="School"
                                aria-label="school"
                                required
                                disabled={true}
                                aria-describedby="sizing-addon1"
                                value={this.state.school}
                                onChange={this.handleUserInput}
                            />
                        </div>
                        <br />
                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><i className="glyphicon glyphicon-user"></i></span>
                            <input
                                name="userName"
                                className="form-control"
                                placeholder="pick a user name"
                                aria-label="userName"
                                required
                                aria-describedby="sizing-addon1"
                                value={this.state.userName}
                                onChange={this.handleUserInput}
                            />
                        </div>
                        <br />
                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><i className="glyphicon glyphicon-envelope"></i></span>
                            <input
                                name="email"
                                className="form-control"
                                placeholder="example@gmail.com"
                                aria-label="email"
                                required
                                type='email'
                                aria-describedby="sizing-addon1"
                                value={this.state.email}
                                onChange={this.handleUserInput}
                            />
                        </div>
                        <br />
                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><i className="glyphicon glyphicon-earphone"></i></span>
                            <NumberFormat
                                name="phone"
                                format="+6#########"
                                // customInput={'input'}
                                className='form-control'
                                placeholder="Enter Phone Number"
                                required
                                value={this.state.phone}
                                onChange={this.handleUserInput}
                            />
                            {/* <input
                                name="phone"
                                className="form-control"
                                placeholder="Enter Phone Number"
                                aria-label="phone"
                                required
                                type='number'
                                aria-describedby="sizing-addon1"
                                value={this.state.phone}
                                onChange={this.handleUserInput}
                            /> */}
                        </div>
                        <br />
                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><i className="glyphicon glyphicon-home"></i></span>
                            <input
                                name="schoolName"
                                className="form-control"
                                placeholder="Enter School Name"
                                aria-label="schoolName"
                                required
                                aria-describedby="sizing-addon1"
                                value={this.state.schoolName}
                                onChange={this.handleUserInput}
                            />
                        </div>
                        <br />
                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><i className="glyphicon glyphicon-edit"></i></span>
                            <input
                                name="students"
                                className="form-control"
                                placeholder="Enter No. of Student"
                                aria-label="No. of Student"
                                required
                                type='number'
                                aria-describedby="sizing-addon1"
                                value={this.state.students}
                                onChange={this.handleUserInput}
                            />
                        </div>
                        <br />

                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><i className="glyphicon glyphicon-flag"></i></span>
                            <select className="form-control" value={this.state.value} onChange={this.handleChange}>
                                <option value="independent">Independent</option>
                                <option value="government">Government</option>
                                <option value="autonomous">Autonomous</option>
                                <option value="private">Private</option>
                                <option value="international">International</option>
                            </select>
                        </div>
                        <br />

                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><i className="glyphicon glyphicon-edit"></i></span>
                            <input
                                name="schoolAddress"
                                className="form-control"
                                placeholder="Enter School Address"
                                aria-label="Enter School Address"
                                required
                                type='schoolAddress'
                                aria-describedby="sizing-addon1"
                                value={this.state.schoolAddress}
                                onChange={this.handleUserInput}
                            />
                        </div>
                        <br />
                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><i className="glyphicon glyphicon-lock"></i></span>
                            <input
                                name="password"
                                className="form-control"
                                placeholder="create password"
                                aria-label="password"
                                required
                                type='password'
                                aria-describedby="sizing-addon1"
                                value={this.state.password}
                                onChange={this.handleUserInput}
                            />
                        </div>
                        <br />
                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><FaKey /></span>
                            <input
                                name="key"
                                className="form-control"
                                aria-label="password"
                                placeholder="passcode for signup"
                                required
                                type='password'
                                aria-describedby="sizing-addon1"
                                value={this.state.key}
                                onChange={this.handleUserInput}
                            />
                        </div>
                        <div className='text-center' style={{ fontSize: 16, color: 'red' }}>
                            <FormErrors formErrors={this.state.formErrors} />
                        </div>
                        <div>
                            {(Error) ? (
                                <div className='text-center' style={{ fontSize: 16, color: 'red' }}>
                                    {Error}
                                </div>
                            ) : (
                                    <span></span>
                                )}
                        </div>
                        <div>
                            {(this.state.selectError) ? (
                                <div className='text-center' style={{ fontSize: 16, color: 'red' }}>
                                    Please Select School Type
                                </div>
                            ) : (
                                    <span></span>
                                )}
                        </div>
                        <div>
                            {(Success) ? (
                                <div className='text-center' style={{ fontSize: 16, color: 'Green' }}>
                                    {Success}
                                </div>
                            ) : (
                                    <span></span>
                                )}
                        </div>
                        <br />
                        <div>
                            {(ALoader === false) ? (
                                <button
                                    onClick={this.SignUp.bind(this)}
                                    className="btn btn-info btn-group-justified"
                                    disabled={!this.state.formValid}
                                    style={{ fontSize: 20 }}
                                >
                                    Sign Up
                                </button>
                            ) : (
                                    <div className='text-Center'>
                                        <mat.LinearProgress mode="indeterminate" color='#1e5a89' />
                                    </div>
                                )}

                        </div>
                    </mat.CardText>
                </mat.Card>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        ALoader: state.authReducers.Loader,
        Success: state.authReducers.success,
        Error: state.authReducers.error
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        SignUpAction: (providers) => {
            dispatch(SignUpAction(providers));
        },
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(SIGNUP);
// export default SIGNUP;


// WEBPACK FOOTER //
// ./src/component/auth/signup.jsx